import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Card, List, Tabs, Tag, Dropdown, Menu } from 'antd';
import { updateCookie } from '../../utils/index';
import { DragSort, DragItem } from '../../components/DragSort';
//DragHandle
import { arrayMoveImmutable } from 'array-move';
import s from './style.m.less';
import { getTenantPortals } from '@/api/gateway';
import { LoadingOutlined,CaretUpOutlined,CaretDownOutlined } from '@ant-design/icons';

@inject('store')
@observer
class SelectTenant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            portalList: [],
            tenantStates: {}, // 合并所有与租户卡片相关的状态，键为tenant_id
            activeTenantId: null, // 当前激活的卡片ID
            selectedTenantId: null // 当前选中的卡片ID，用于高亮显示
        };
        this.cardRefs = {}; // 存储卡片的DOM引用
    }
    outLogin = () => {
        const {
            store: { login }
        } = this.props;

        login.outLogin();
    };
    enter = (item) => {
        const {
            store: { login }
        } = this.props;
        if (login.activeIdentity === 'admin') {
            updateCookie(item);
            window.location.href = `https://${item.domain}`;
        }
        return;
    };

    //拖拽
    onSortEnd = (dragProps) => {
        const {
            store: { login }
        } = this.props;
        let { oldIndex, newIndex } = dragProps;

        if (oldIndex !== newIndex) {
            const newData = arrayMoveImmutable(login.showTenantList.slice(), oldIndex, newIndex).filter((el) => Boolean(el));

            let ids = [];
            newData.forEach((ele) => {
                ids.push(ele.id);
            });

            // login.tenantSort(ids);
        }
    };

    // 计算下拉菜单的方向
    calculateDropdownPlacement = (tenantId) => {
        const cardElement = this.cardRefs[tenantId];
        if (!cardElement) return 'bottom';
        const cardRect = cardElement.getBoundingClientRect(),
        windowHeight = window.innerHeight,
        dropdownHeight = 300; // 预估下拉菜单高度
        // 判断卡片下方空间是否足够显示下拉菜单
        if (cardRect.bottom + dropdownHeight > windowHeight) {
            return 'top'; // 空间不足，向上显示
        }
        return 'bottom'; // 空间足够，向下显示
    };
    getPortalList = async (item) => {
        // 设置加载状态
        this.setState({
            tenantStates: {
                ...this.state.tenantStates,
                [item.tenant_id]: {
                    ...this.state.tenantStates[item.tenant_id],
                    loading: true
                }
            }
        });
        try {
            let res = await getTenantPortals({ tenant_id: item.tenant_id }),
            data = res?.data ? res.data : [];
            // 计算下拉菜单方向
            const placement = this.calculateDropdownPlacement(item.tenant_id);
            // 请求成功，更新状态
            this.setState({
                portalList: data,
                tenantStates: {
                    ...this.state.tenantStates,
                    [item.tenant_id]: {
                        ...this.state.tenantStates[item.tenant_id],
                        loading: false,
                        placement: placement,
                        dropdownOpen: true
                    }
                }
            });
        } catch (error) {
            console.error('获取租户门户数据失败:', error);
            // 请求失败或超时，也要将loading状态设置为false
            this.setState({
                tenantStates: {
                    ...this.state.tenantStates,
                    [item.tenant_id]: {
                        ...this.state.tenantStates[item.tenant_id],
                        loading: false
                    }
                }
            });
        }
    };

    onClickMenu = (item, ele) => {
        const {
            store: { login }
        } = this.props;
        if (login.activeIdentity === 'student') {
            window.location.href = `https://${item.domain}/web?source_id=${ele.portal_id}`;
        }
        return;
    };

    renderDropdownContent = (item) => {
        // 获取当前卡片的加载状态（使用tenantStates中的状态）
        const tenantState = this.state.tenantStates[item.tenant_id] || {},
        isLoading = tenantState.loading;
        return (
            <Menu>
                {isLoading ? (
                    null
                ) : this.state.portalList?.length ? (
                    this.state.portalList.map((ele) => {
                        return (
                            <Menu.Item key={ele.portal_id} onClick={() => this.onClickMenu(item, ele)}>
                                {ele.portal_name}
                            </Menu.Item>
                        );
                    })
                ) : (
                    <Menu.Item key="empty">暂无数据</Menu.Item>
                )}
            </Menu>
        );
    };
    render() {
        const {
            store: { login }
        } = this.props;

        return (
            <div style={{ height: '630px', paddingTop: '16px', overflowY: 'auto', overflowX: 'hidden' }}>
                <Tabs
                    activeKey={login.activeIdentity}
                    onChange={(e) => {
                        login.setActiveIdentity(e);
                    }}
                    items={[
                        {
                            label: '学员身份',
                            key: 'student',
                            children: <></>
                        },
                        {
                            label: '管理员身份',
                            key: 'admin',
                            children: <></>
                        }
                    ]}
                />

                {login.showTenantList?.length ? (
                    <DragSort onSortEnd={this.onSortEnd} useDragHandle key={'custom'} helperClass={s['sortableHelper']}>
                        <List
                            grid={{
                                gutter: 24,
                                column: 2
                            }}
                            className={s.list_box}
                            dataSource={login.showTenantList}
                            renderItem={(item, index) => (
                                <DragItem key={item.tenant_id} index={index}>
                                    <List.Item
                                        key={item.tenant_id}
                                        onClick={() => {
                                            this.enter(item);
                                        }}
                                    >
                                        <div className={s.tag}>
                                            {item.state === 0 ? null : (
                                                <Tag style={{ width: '78px' }} color="#FF3200">
                                                    {item.state === 1 ? ' 账号被停用' : item.state === 2 ? '租户被停用' : '租户已过期'}
                                                </Tag>
                                            )}
                                        </div>
                                        {login.activeIdentity === 'student' ? (
                                            <Dropdown
                                                overlay={this.renderDropdownContent(item)}
                                                overlayClassName={s['drop-class']}
                                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                                placement={(this.state.tenantStates[item.tenant_id]?.placement) || 'bottom'}
                                                autoFocus={false}
                                                trigger={['click']} // 保留点击触发，确保外部点击关闭功能正常
                                                open={(this.state.tenantStates[item.tenant_id]?.dropdownOpen) || false} // 手动控制显示状态
                                                onOpenChange={(open) => {
                                                    if (open) {
                                                        // 点击卡片打开Dropdown时，加载数据
                                                        this.setState({
                                                            activeTenantId: item.tenant_id,
                                                            selectedTenantId: item.tenant_id // 点击时高亮卡片
                                                        });
                                                        this.getPortalList(item);
                                                    } else {
                                                        // 点击外部关闭Dropdown时，更新状态
                                                        this.setState(prevState => ({
                                                            tenantStates: {
                                                                ...prevState.tenantStates,
                                                                [item.tenant_id]: {
                                                                    ...prevState.tenantStates[item.tenant_id],
                                                                    dropdownOpen: false
                                                                }
                                                            },
                                                            selectedTenantId: null // 关闭时移除高亮
                                                        }));
                                                    }
                                                }}
                                            >
                                                <Card
                                                    hoverable
                                                    ref={ref => this.cardRefs[item.tenant_id] === ref}
                                                    className={this.state.selectedTenantId === item.tenant_id ? 'main-card-cur' : ''}
                                                >
                                                    <div
                                                        style={{
                                                            marginBottom: 0,
                                                            fontSize: '14px',
                                                            fontWeight: '400',
                                                            textAlign: 'center',
                                                            lineHeight: '38px'
                                                        }}
                                                    >
                                                        {item.tenant_name} {(this.state.tenantStates[item.tenant_id]?.loading) ? <LoadingOutlined /> : null}
                                                        <span className={this.state.selectedTenantId === item.tenant_id ? 'main-card-icon main-card-iconCur' : 'main-card-icon'}>{this.state.selectedTenantId === item.tenant_id ? <CaretUpOutlined /> : <CaretDownOutlined/>}</span>
                                                    </div>
                                                </Card>
                                            </Dropdown>
                                        ) : (
                                            <Card
                                                hoverable
                                                className={this.state.selectedTenantId === item.tenant_id ? 'main-card-cur' : ''}
                                                onClick={() => {
                                                    // 点击非学生卡片时，高亮当前卡片，点击其他卡片或空白区域时移除高亮
                                                    this.setState(prevState => ({
                                                        selectedTenantId: prevState.selectedTenantId === item.tenant_id ? null : item.tenant_id
                                                    }));
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        marginBottom: 0,
                                                        fontSize: '14px',
                                                        fontWeight: '400',
                                                        textAlign: 'center',
                                                        lineHeight: '38px'
                                                    }}
                                                >
                                                    {item.tenant_name}
                                                </div>
                                            </Card>
                                        )}
                                    </List.Item>
                                </DragItem>
                            )}
                        />
                    </DragSort>
                ) : (
                    <div span={24} style={{ margin: '100px auto 0', textAlign: 'center' }}>
                        <div className={s.search_empty}></div>
                        <div
                            style={{
                                fontSize: '12px',
                                color: '#999'
                            }}
                        >
                            您当前暂无其他组织
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default SelectTenant;

